import AkFeatureGates from '@atlaskit/feature-gate-js-client';

const checkFeatureGate = (feature: string): boolean => AkFeatureGates.checkGate(feature);

// Async variant that waits for feature-gate initialization before reading the
// gate. Route thunks can run before the client is initialized, in which case
// the sync checkGate returns the default (false). Awaiting readiness avoids
// that race (e.g. wrongly falling back to a deactivated API path).
export const checkFeatureGateAsync = async (feature: string): Promise<boolean> => {
  try {
    await AkFeatureGates.waitUntilInitializeCompleted();
  } catch {
    // If initialization fails, fall back to the current (default) value.
  }
  return AkFeatureGates.checkGate(feature);
};

export default checkFeatureGate;
